import { render, staticRenderFns } from "./HeadingGift.vue?vue&type=template&id=54465afb&lang=pug&"
import script from "./HeadingGift.vue?vue&type=script&lang=js&"
export * from "./HeadingGift.vue?vue&type=script&lang=js&"
import style0 from "./HeadingGift.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports